import { EPromoType, IPromo } from '../../types/newbuilding/promos';
import { IApplicationState } from '../../types/redux';
import { getPromo } from './getPromo';
import { getPromos } from './getPromos';

export const getPromosForPreview = (state: IApplicationState): IPromo[] => {
  const promos = getPromos(state);
  const mainPromo = getPromo(state);

  const promosToPreview = (promos as IPromo[])
    .filter(promo => promo.promoId !== mainPromo?.promoId)
    .filter(promo => {
      if (promo.promoType === EPromoType.Bank) {
        return !!promo.bank && !!promo.bank.secondRoundImageUrl;
      }

      return promo;
    });

  return promosToPreview.slice(0, 2);
};
